<div class="center">
  <div>
  <img class="shopify-logo" src="../../../../../../assets//pos/shopify.png">
  <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
  </div>
</div>